
import VButton from '~/components/ui/VButton'
import { mapGetters } from 'vuex'

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        body: {
            type: String,
            default: ''
        },
        buttons: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ])
    },
    components: {
        VButton
    }
}
